import templateUrl from './edit-feedback-modal.component.html'
import { EmployeeService, MessageService } from '../../../core/services';
import { UtilityService } from '../../../core/services/utility.service';
import { EmployeeIdentityResponse, MessageCreateRequest, MessageTypeEnum } from '@herbjoy/apex-api-models';
import { ValueEmitter, CancelValue } from '../modals/modal-types';
import { StateService } from 'angular-ui-router';

interface FeedbackVM {
    rating?: {
        rating: number;
        text: string;
    };
    comments?: string;
}

export class EditFeedbackModalController {
    dismiss: ValueEmitter<CancelValue>;
    close: ValueEmitter<MessageCreateRequest>;
    feedback: FeedbackVM;
    user: EmployeeIdentityResponse;
    submitting = false;
    constructor(private $state: StateService, private employeeService: EmployeeService,
        private messageService: MessageService, private utilityService: UtilityService) {
        'ngInject'
        this.employeeService = employeeService
        this.messageService = messageService
        this.utilityService = utilityService
        this.feedback = {};
    }

    $onInit() {
        this.utilityService.showLoading();
        // Load some optional data for the feedback.
        // Allow feedback to continue if this fails.
        this.employeeService.retrieveIdentity()
            .then(user => {
                this.user = user;
                return this.user;
            })
            .catch(() => { })
            .then(() => {
                this.utilityService.hideLoading();
            });
    }

    onSaveClick() {
        this.submitting = true;
        const message = this.createMessage(this.feedback, this.user);
        this.messageService.createMessage(message)
            .then(() => {
                this.close({ $value: message });
            })
            .catch(ex => {
                console.error(ex);
                alert("Sending feedback failed: " + this.utilityService.getExceptionMessage(ex));
            })
            .then(() => {
                this.submitting = false;
            });
    }

    onCancelClick() {
        this.dismiss({ $value: 'cancel' });
    }

    private createMessage(feedback: FeedbackVM, user: EmployeeIdentityResponse) {
        let fullName = "Anonymous";
        if (user) {
            fullName = `${user.FirstName} ${user.LastName}`;
        }
        let body = `<h5>New feedback from ${fullName}</h5>`;
        if (feedback.rating) {
            const rating = feedback.rating;
            body += `<p>${fullName} gave the site a ${rating.rating} star rating (${rating.text})`;
            if (feedback.comments) {
                body += " and left the following message:";
            }
            body += "</p>";
        }
        if (feedback.comments) {
            body += `<pre>${feedback.comments}</pre>`
        }
        body += `
            <h5>Context</h5>
            <code>
                url=${window.location.href}
                state=${this.$state.current.name}
            </code>`
        return {
            MessageTypeId: MessageTypeEnum.UserFeedback,
            Subject: `New feedback from ${fullName}`,
            Body: body,
            Importance: feedback.rating && feedback.rating.rating < 3 && !!feedback.comments
        };
    }
}

export const EditFeedbackModalComponent = {
    selector: "apexEditFeedbackModal",
    templateUrl,
    controller: EditFeedbackModalController,
    controllerAs: "vm",
    bindings: {
        close: "&",
        dismiss: "&"
    }
}

export const EditFeedbackModal = {
    component: EditFeedbackModalComponent.selector,
    windowClass: "xx-dialog pagespinner",
    size: "md",
    backdrop: "static"
}

